export default class Trip {
	id: number;
	carName?: string;
	carRegisterNumber?: string;
	startDateTime: string;
	endDateTime: string;
	startPlace: string;
	startPlaceId: number;
	endPlace: string;
	endPlaceId: number;
	passengerId: number;
	movitPassengerId: string;
	cancelledAt?: string;
	cancelledBy?: string;
	cancelReason?: string;
	pickupTime?: string;
	dropoffTime?: string;
	noShowTime?: string;
	selectedForCancelling: boolean;
	passenger: TripPassenger;
	status: TripStatus;
	drivereventdropoffisacc: boolean;
	drivereventpickupisacc: boolean;

	constructor(options) {
		this.id = options && options.id ? options.id : null;
		this.passengerId = options && options.passengerId ? options.passengerId : null;
		this.carName = options && options.carName ? options.carName : null;
		this.carRegisterNumber = options && options.carRegisterNumber ? options.carRegisterNumber : null;
		this.startDateTime = options && options.startDateTime ? options.startDateTime : null;
		this.endDateTime = options && options.endDateTime ? options.endDateTime : null;
		this.startPlace = options && options.startPlace ? options.startPlace : null;
		this.endPlace = options && options.endPlace ? options.endPlace : null;
		this.movitPassengerId = options && options.movitPassengerId ? options.movitPassengerId : null;
		this.cancelledAt = options && options.cancelledAt ? options.cancelledAt : null;
		this.cancelledBy = options && options.cancelledBy ? options.cancelledBy : null;
		this.cancelReason = options && options.cancelReason ? options.cancelReason : null;
		this.pickupTime = options && options.pickupTime ? options.pickupTime : null;
		this.dropoffTime = options && options.dropoffTime ? options.dropoffTime : null;
		this.noShowTime = options && options.noShowTime ? options.noShowTime : null;
		this.passenger = options && options.passenger ? options.passenger : null;
		this.selectedForCancelling = false;
		this.status = options && options.status ? options.status : null;
		this.drivereventdropoffisacc = options?.drivereventdropoffisacc ?? false;
		this.drivereventpickupisacc = options?.drivereventpickupisacc ?? false;
	}

	public static WithPassengerId(tripFromApi, passengerId: number) {
		const trip = new Trip(tripFromApi);
		trip.passengerId = passengerId;
		return trip;
	}

	get date() {
		const test =  (this.startDateTime || this.endDateTime).split('T');
		return test[0]
	}
}

export class TripPassenger {
	timitId: number;
	name: string;
}

export class TripStatus {
	code: TripStatusCode;
	/** Estimated Time of Arrival. Whan passenger is at the end destination and gets off the ride. */
	eta: Date | string;
	/** Estimated Time of Departure. When passenger is at the start destination and gets on the ride. */
	etd: Date | string;

	/** First event time in start place */
	arrivalToPickup: Date | string;

	/** Actual Time of Arrival. Whan passenger arrived at the end destination and got off the ride. */
	ata: Date | string;
	/** Actual Time of Departure. When passenger departed from the start destination and got on the ride. */
	atd: Date | string;
}

export enum TripStatusCode
{
    Unknown = 0,
    Booked = 1,
    Routed = 2,
    Dispatching = 3,
    Dispatched = 4,
    Cancelled = 5,

    EnRoute = 10,
    CarWaiting = 11,
    NoShow = 12,
    Pickup = 13,
    DropOff = 14,
}
